<div class="login-box">
    <div class="lds-ring" style="margin-left: 85px;">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
</div>